import { PollPdfService } from '../../services/poll-pdf.service';
import { PollDialogComponent } from '../poll-dialog/poll-dialog.component';
import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA, MdDialog } from '@angular/material';
import { Observable } from "rxjs";
import { PollService } from '../../services/poll.service';

@Component({
  selector: 'app-poll-list-dialog',
  templateUrl: './poll-list-dialog.component.html',
  styleUrls: ['./poll-list-dialog.component.css']
})


export class PollListDialogComponent implements OnInit {

  polls: Observable<any[]>;
  pollLoading: boolean;
  pollMax = 6;
  pollPage = 1;
  pollTotal = 0;
  job_id: string;
  errorMessage: string;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    public poll: PollService,
    public pdfpoll: PollPdfService,
    private dialog: MdDialog,
    public dialogRef: MdDialogRef<PollListDialogComponent>) { }

  ngOnInit() {
    this.pollMax = this.data.pollMax;
    this.job_id = this.data.job_id;
    this.fetchpolls(1);
  }

  goToPoll(poll) {
    const dialogRef = this.dialog.open(PollDialogComponent, {data: {
      pollid: poll.id,
      pollIMax: 6,
      poll: poll,
      job_id: this.job_id

    }});
    dialogRef.afterClosed().subscribe(result => {});
  }

  goToExcel(poll) {
    console.log(poll);
    this.pdfpoll.getPoll(poll.id, this.job_id).subscribe(
      res => {
        const fileURL = URL.createObjectURL(res);
        const link = document.createElement('a');
        link.download = 'encuesta.pdf';
        link.target = '_blank';
        link.href = fileURL;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      error => {
        this.pollLoading = false;
      }
    );
    //this.excel.exportAsExcelFile(poll, this.job_id);
  }

  fetchpolls(page) {
    this.pollLoading = true;
    this.poll.getPollsByJob(page, this.pollMax, this.job_id, 1)
      .subscribe(
        res => {
          this.pollTotal = res.pagination.total;
          this.pollPage = page;
          this.pollLoading = false;
          this.polls = res.polls;
        },
        error => {
          this.pollLoading = false;
        }
      );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/poll-list-dialog/poll-list-dialog.component.ts